import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

const searchSchema = z.object({
  redirect: z.string().optional(),
  email: z.string().optional(),
})

export const Route = createFileRoute("/_auth/sign-in")({
  validateSearch: searchSchema,
  staticData: { title: "Sign In" },
  beforeLoad: ({ context, search }) => {
    if (context.userInfo.state === "LoggedIn") {
      throw redirect({ to: search.redirect ?? "/" })
    }
  },
  component: lazyRouteComponent(() => import("#pages/login/sign-in.tsx"), "SignIn"),
})
